/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from './defs.defs.js'

const $nsid = 'app.bsky.graph.getStarterPacksWithMembership'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  actor: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  starterPacksWithMembership: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<StarterPackWithMembership>(
      (() => starterPackWithMembership) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerates the starter packs created by the session user, and includes membership information about `actor` in those starter packs. Requires auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

/** A starter pack and an optional list item indicating membership of a target user to that starter pack. */
type StarterPackWithMembership = {
  $type?: 'app.bsky.graph.getStarterPacksWithMembership#starterPackWithMembership'
  starterPack: GraphDefs.StarterPackView
  listItem?: GraphDefs.ListItemView
}

export type { StarterPackWithMembership }

/** A starter pack and an optional list item indicating membership of a target user to that starter pack. */
const starterPackWithMembership =
  /*#__PURE__*/ l.typedObject<StarterPackWithMembership>(
    $nsid,
    'starterPackWithMembership',
    /*#__PURE__*/ l.object({
      starterPack: /*#__PURE__*/ l.ref<GraphDefs.StarterPackView>(
        (() => GraphDefs.starterPackView) as any,
      ),
      listItem: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.ref<GraphDefs.ListItemView>(
          (() => GraphDefs.listItemView) as any,
        ),
      ),
    }),
  )

export { starterPackWithMembership }
